import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider1 from '../../assets/images/banner1.jpg'
import slider2 from '../../assets/images/banner3.jpg';
import slider3 from '../../assets/images/banner2.jpg'

function HeroBanner() {
  
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const slides = [
    {
      image: slider1,
      // smallTitle: "Home Decore",
      title: "Home Decore",
      subtitle: "Hight Quality Home Decor Product",
      align: "left"
    },
    {
      image: slider2,
      // smallTitle: "Home Decore",
      title: "Carpets",
      subtitle: "Best and Hight Quality Carpet Product",
      align: "left"
    },
    {
      image: slider3,
      title: "Bath Mat",
      subtitle: "Best and Hight Quality Bath Mat Product",
      align: "right"
    }
  ];

  return (

   <> 

    <div className="slideshow slideshow-wrapper">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="slide" key={index}>
              <div className="blur-up lazyloaded">
                <img
                  src={slide.image}
                  alt={slide.title}
                  title={slide.title}
                  />
                 <div className={`slideshow__text-wrap slideshow__overlay ${slide.align}`}>
                  <div className="slideshow__text-content">
                    <div className={`wrap-caption anim-tru ${slide.align} style1`}>
                      {slide.smallTitle && (
                        <p className="mega-small-title">{slide.smallTitle}</p>
                      )}
                      <h2 className="h1 mega-title slideshow__title">{slide.title}</h2>
                      <span className="mega-subtitle slideshow__subtitle">{slide.subtitle}</span>
                      <span className="btn">Shop now</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
    </div>
   
   </>
  );
}
export default HeroBanner;

